import React, {Component} from 'react'
import {TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap'
import { NavLink as RouterNavLink } from 'react-router-dom';

class TabList extends Component {
  constructor() {
    super()
    this.activeTab = 0;
  }

  createNavItem(tabIndex, tabLabel, navLink) {
    return (
      <NavItem key={tabIndex.toString()}>
        <NavLink
          className={this.activeTab === tabIndex ? 'active' : ''}
          tag={RouterNavLink}
          to={navLink}>
          {tabLabel}
        </NavLink>
      </NavItem>
    )
  }

  createTabPanel(tabIndex, content) {
    let tabContent;
    if (this.activeTab === tabIndex) {
      tabContent = content;
    }
    else {
      tabContent = null;
    }
    return (
      <TabPane tabId={tabIndex.toString()} key={tabIndex.toString()}>
        {tabContent}
      </TabPane>
    )
  }

  getActiveTabIndex() {
    let pathname = this.props.location.pathname
    let urlParts = pathname && pathname.split('/').filter(str => str.trim().length > 0)

    if (urlParts.length < 1) {
      return 0;
    }

    for (let tabIndex = 0; tabIndex < this.props.contentItems.length; tabIndex++) {
      let item = this.props.contentItems[tabIndex];

      if (item.link === urlParts[urlParts.length - 1]) {
        return tabIndex;
      }
    }
  }

  render() {
    if (!this.props.contentItems){
      return (<div />);
    }

    this.activeTab = this.getActiveTabIndex();
    
    let navItems = [];
    let tabPanels = [];
    let tabIndex = 0;

    this.props.contentItems.forEach((item) => {
      navItems.push(this.createNavItem(tabIndex, item.label, item.link));
      tabPanels.push(this.createTabPanel(tabIndex, item.content));
      tabIndex++;
    })

    return (
      <div>
        <Nav tabs>
          {navItems}
        </Nav>
        <TabContent activeTab={this.activeTab.toString()}>
          {tabPanels}
        </TabContent>
      </div>
    )
  }
}

export default TabList